import { useQuery } from '@deity/falcon-data';
import { GET_CUSTOMER } from '../../overrides/Customer/CustomerQuery';

export const InitQueryLoader = () => {
  useQuery(GET_CUSTOMER, { fetchPolicy: 'network-only' });
  return null;
};
